import { memo, useRef } from 'react';

import { type MentionsData } from '~/components/DiscussionsV2/DiscussionForm';
import { UserMentionTooltip } from '~/components/DiscussionsV2/UserMention/components/UserMentionTooltip';
import { useHover } from '~/hooks/useHover';

export type UserMentionProps = {
  userName: string;
  user?: MentionsData;
};

export const UserMention = memo(({ userName, user }: UserMentionProps) => {
  const textRef = useRef<HTMLElement>(null);
  const { handleHover, isHovering, handleUnhover } = useHover();

  return (
    // biome-ignore lint/a11y/noStaticElementInteractions: the mention span only toggles a hover tooltip and is not a control
    <span data-testid="USER_MENTION" data-user-name={userName} onMouseEnter={handleHover} onMouseLeave={handleUnhover}>
      {isHovering && user && <UserMentionTooltip containerRef={textRef} user={user} />}
      <span className="cursor-pointer font-medium ads:text-secondary text-14 text-gray-11" ref={textRef}>
        {userName}
      </span>
    </span>
  );
});

UserMention.displayName = 'UserMention';
